import React from 'react';
import Rating from '../Rating/Rating';
import GoogleMessageIcon from '../../../../../assets/GoogleMessageIcon.png';

const MainContent = ({ scrollToProductPage, scrollToTrial, desktopMobileImage, fasterGrowingBadge, customerSupportBadge, mainPageTitleText, mainPageDescription }) => (
  <div className="main-content">
    <div className="text-container">
      <h1>{mainPageTitleText}</h1>
      <p>{mainPageDescription}</p>
      <img src={desktopMobileImage} alt="Screen" className="screen-image mobile" />
      <div className="badges">
        <img src={fasterGrowingBadge} alt="Faster Growing Software Badge" className="badge-image" />
        <img src={customerSupportBadge} alt="Customer Support Badge" className="badge-image" />
        {/* <img src={highPerformerBadge} alt="High Performer Badge" className="badge-image" /> */}
        <div className="rating">
          <img src={GoogleMessageIcon} alt="GoogleIcon" className="GoogleMesageIcon" />
          <span style={{textAlign:'center'}}>Google Reviews</span>
          <b><Rating rating={4.8} /></b>
        </div>
      </div>
      <div className="buttons">
        <button className="button-buynow" onClick={scrollToProductPage}>Buy Now</button>
        <button className="button-requestdemo" onClick={scrollToTrial}>Free Trial</button>
      </div>
    </div>
    <img src={desktopMobileImage} alt="Screen" className="screen-image desktop" />
  </div>
);

export default MainContent;
